module.exports = __webpack_public_path__ + "media/images/view_mode_details-75b810e9.svg";